import { defineComponent as x, createBlock as i, openBlock as l, unref as a, withCtx as t, createElementVNode as c, normalizeClass as o, createVNode as m, createElementBlock as r, createCommentVNode as d, normalizeStyle as w, createTextVNode as b, toDisplayString as y, renderSlot as n, reactive as g } from "vue";
import { Dialog as z, DialogPanel as k, DialogTitle as C } from "@headlessui/vue";
import { cva as f, cx as v } from "@scalar/use-hooks/useBindCx";
import S from "../ScalarIconButton/ScalarIconButton.vue.js";
const $ = {
  key: 0,
  class: "close-button z-10 fixed right-2 top-2"
};
function W() {
  return g({
    open: !1,
    show() {
      this.open = !0;
    },
    hide() {
      this.open = !1;
    }
  });
}
const E = /* @__PURE__ */ x({
  __name: "ScalarModal",
  props: {
    state: {},
    title: {},
    bodyClass: {},
    maxWidth: {},
    size: { default: "md" },
    variant: {}
  },
  setup(D) {
    const p = f({
      base: [
        "scalar-modal",
        "flex flex-col relative mb-0 rounded-lg bg-b-1 p-0 text-left leading-snug text-c-1 opacity-0 w-[calc(100vw-12px)] md:w-[calc(100vw-16px)] lg:w-[calc(100vw-32px)]"
      ].join(" "),
      variants: {
        size: {
          xxs: "mt-[20svh] max-h-[60svh] max-w-[360px]",
          xs: "mt-[20svh] max-h-[60svh] max-w-[480px]",
          sm: "mt-[20svh] max-h-[60svh] max-w-[540px]",
          md: "mt-[20svh] max-h-[60svh] max-w-[640px]",
          lg: "m-auto max-h-[80svh] max-w-[800px]",
          xl: "m-auto max-h-[90svh] max-w-[1000px]",
          full: "full-size-styles max-h-dvh mt-0 lg:w-full"
        },
        variant: {
          form: "scalar-modal-form",
          search: "scalar-modal-search mt-[15svh] max-h-[60svh] max-w-[540px]",
          error: "scalar-modal-error"
        }
      }
    }), u = f({
      base: ["scalar-modal-body", "relative flex-1 min-h-0 p-3"].join(" "),
      variants: {
        variant: {
          form: "overflow-visible",
          search: "flex flex-col !m-0 overflow-hidden p-0",
          error: "overflow-y-scroll"
        },
        size: {
          xxs: "",
          xs: "",
          sm: "",
          md: "",
          lg: "",
          xl: "m-0 p-0",
          full: " rounded-none"
        }
      }
    });
    return (e, s) => (l(), i(a(z), {
      open: e.state.open,
      onClose: s[1] || (s[1] = (h) => e.state.hide())
    }, {
      default: t(() => [
        c("div", {
          class: o(
            a(v)(
              e.size === "full" ? "scalar-modal-layout-full" : "scalar-modal-layout",
              "fixed left-0 top-0 flex items-start justify-center",
              "z-[1001] h-[100dvh] w-[100dvw]",
              "bg-backdrop opacity-0 dark:bg-backdrop-dark",
              e.size === "full" && "flex"
            )
          )
        }, [
          m(a(k), {
            class: o(a(p)({ size: e.size, variant: e.variant })),
            style: w({ maxWidth: e.maxWidth })
          }, {
            default: t(() => [
              e.title ? (l(), i(a(C), {
                key: 0,
                class: "scalar-modal-header m-0 -mb-1 rounded-lg pt-3 px-3 text-left text-sm font-medium text-c-1"
              }, {
                default: t(() => [
                  b(y(e.title), 1)
                ]),
                _: 1
              })) : d("", !0),
              e.size === "full" ? (l(), r("div", {
                key: 1,
                class: o(e.bodyClass)
              }, [
                n(e.$slots, "default", {}, void 0, !0)
              ], 2)) : (l(), r("div", {
                key: 2,
                class: o(a(v)(a(u)({ size: e.size, variant: e.variant }), e.bodyClass))
              }, [
                n(e.$slots, "default", {}, void 0, !0)
              ], 2))
            ]),
            _: 3
          }, 8, ["class", "style"]),
          e.size === "full" ? (l(), r("div", $, [
            m(a(S), {
              class: "hover:bg-b-3 focus:outline-none",
              icon: "Close",
              label: "Clear Search",
              onClose: s[0] || (s[0] = (h) => e.state.hide())
            })
          ])) : d("", !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["open"]));
  }
});
export {
  E as default,
  W as useModal
};
